import './assets/Footer.css';const root = "_root_g7afj_2";
const image = "_image_g7afj_9";
const container = "_container_g7afj_15";
const brandBarWrapper = "_brandBarWrapper_g7afj_39";
const brandBar = "_brandBar_g7afj_39";
const address = "_address_g7afj_59";
const addressItem = "_addressItem_g7afj_64";
const contactWrapper = "_contactWrapper_g7afj_71";
const contact = "_contact_g7afj_71";
const otherSitesWrapper = "_otherSitesWrapper_g7afj_101";
const otherSites = "_otherSites_g7afj_101";
const linksWrapper = "_linksWrapper_g7afj_111";
const contentLinks = "_contentLinks_g7afj_120";
const linksGroup = "_linksGroup_g7afj_129";
const link = "_link_g7afj_111";
const FooterStyles = {
  root,
  image,
  container,
  brandBarWrapper,
  brandBar,
  address,
  addressItem,
  contactWrapper,
  contact,
  otherSitesWrapper,
  otherSites,
  linksWrapper,
  contentLinks,
  linksGroup,
  link
};
export {
  FooterStyles as F
};
